var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('el-tooltip',{staticClass:"align-middle",attrs:{"content":"点击预览大图"}},[_c('el-image',{staticStyle:{"height":"30px"},attrs:{"src":_vm.img,"preview-src-list":[_vm.img]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }